import React, { useState } from 'react';
import intl from '$intl';
import StoreModel from '$fbusiness/models/store';
import Div from '$gstyles/div';
import { dialog, FormSection } from '$gcomponents/reusables';
import { Button } from '$gcomponents/primitives';
import { Add, DeleteOutlined, EditOutlined } from '@mui/icons-material';
import { accessHide, getAccess } from '$fbusiness/helpers/util';
import { initialBank } from '$fbusiness/models/bank';
import { itemText } from '$gbusiness/helpers/util';
import CurrentStateModel from '$fbusiness/models/currentState';
import { Flex } from '$gstyles/wrapper';
import { IconButton } from '@mui/material';
import { BankWrapper } from './styles';
import BankModal from './bankModal';
import { factoryActions } from '$fbusiness/redux/factory';
import { configs } from '$configs';
import { useDispatch } from 'react-redux';
import { storeActions } from '$fbusiness/redux/store';

interface BanksListProps {
  store: StoreModel;
  currentState: CurrentStateModel;
}

const BanksList: React.FC<BanksListProps> = ({ store, currentState }) => {
  const { banks } = store;
  const dispatch = useDispatch();
  const [bank, setBank] = useState<any>(null);

  const ACCESS = getAccess(currentState);

  const deleteBank = (id: number) => {
    dialog.confirm({
      message: 'MESSAGE.DELETE_WARNING',
      onPress: async () => {
        const bankId = id;
        await dispatch(factoryActions.deleteObj(bankId, configs.api.bank)).then(() => {
          dispatch(storeActions.fetchStore(store.id));
        });
      },
    });
  };

  return (
    <BankWrapper maxWidth="500px" className="container">
      <FormSection
        className="form-section"
        title="SCREEN.STORES.BANK.TITLE"
        FORM={[]}
        marginBottom="0"
        titleButton={
          <Button
            startIcon={<Add />}
            size="small"
            color="secondary"
            className={accessHide(ACCESS.ACTION.SETTING.BANK?.CREATE)}
            onClick={() => setBank(initialBank)}>
            {itemText('add', intl('COMMON.BANK'))}
          </Button>
        }
        formik={null}>
        <Div className="tax-section">
          {banks?.map((shipping, i) => {
            return (
              <Flex key={i}>
                <Flex>
                  <div className="item-name">{shipping.name}</div>
                </Flex>
                <Flex>
                  <IconButton
                    onClick={() => setBank(shipping)}
                    className={accessHide(ACCESS.ACTION.SETTING.BANK?.EDIT)}>
                    <EditOutlined />
                  </IconButton>
                  <IconButton
                    onClick={() => deleteBank(shipping.id)}
                    className={accessHide(ACCESS.ACTION.SETTING.BANK?.DELETE)}>
                    <DeleteOutlined />
                  </IconButton>
                </Flex>
              </Flex>
            );
          })}
        </Div>
      </FormSection>
      <BankModal store={store} bank={bank} onClose={() => setBank(null)} />
    </BankWrapper>
  );
};

export default BanksList;
